var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},_vm._l((_vm.columns),function(blok,i){return _c(blok.component,_vm._b({key:'grid-' + i,tag:"component"},'component',blok,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }